import styled, { css } from 'styled-components';
import { mobile_xl, mobile_xs } from '../../../global/mediaQueryMixin';
import { AlignCenter } from '../../../global/commonStyle';

const Main = styled.div`
  width: 100%;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  .loading-animation {
    overflow: hidden;
  }

  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const Box = styled.div`
  border-bottom: 0.5px solid var(--border-primary);
  padding: var(--space-16);
  display: flex;
  gap: var(--space-40);
  justify-content: space-between;
  :last-child {
    border-bottom: none;
  }
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-12);
  `)}
`;
const Div = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-16);
    flex-direction: column;
    align-items: flex-start;
  `)}
`;
const First = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
`;

const Circle = styled.div`
  width: 18px;
  height: 18px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;
const Longline = styled.div`
  width: 122px;
  height: 10px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  ${mobile_xl(css`
    width: 230px;
    height: 12px;
  `)}
  ${mobile_xs(css`
    width: 215px;
  `)}
`;
const ShortLine = styled.div`
  width: 100px;
  height: 8px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  ${mobile_xl(css`
    width: 142px;
    height: 10px;
  `)}
`;

const Second = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  ${mobile_xl(css`
    display: none;
  `)}
`;

const Third = styled.div`
  display: flex;
  ${mobile_xl(css`
    padding-left: var(--space-40);
  `)}
`;

const Smallcircle = styled.div`
  width: 10px;
  height: 10px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;
const Line = styled.div`
  width: 122px;
  height: 8px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const UserLogo = styled.div`
  width: 20px;
  height: 20px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  border: 2px solid var(--background-primary);
  margin-left: -9px;
`;

const CircleDiv = styled.div`
  width: 18px;
  height: 18px;
`;
export { Main, Box, First, Second, Third, Circle, Longline, ShortLine, Line, Smallcircle, UserLogo, Div, CircleDiv };
